import { documentIdentificationTypeApi } from "../../api";

const DocumentIdentificationTypeService = {
  fetchDropdown: async () => {
    const response = await documentIdentificationTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default DocumentIdentificationTypeService;
